export default __webpack_public_path__ + "static/O0233-e19e51d368c0c811dfe0fa6c427ecd68.png";